import React from "react";
import NodeDetailView from "./NodeDetail";

const NodeDetail: React.FC = () => {
  return <NodeDetailView />;
};

export default NodeDetail;
